import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Button, InputAdornment } from '@material-ui/core'
import { CurrencyFormValidation } from '../../utils/validationSchema'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormSelectField from '../FormSelectField'
import currencyList from '../../configurations/currency-codes.json'
import FormTextField from '../FormTextField'
import { calculateDecimal } from '../../utils/helpers'

const CurrencyForm = ({ currentData, onSubmit, locale, cancelDialog, currentAction, updateParentEntity, currenciesKeys }) => {
  const classes = formStyles()
  const [currentCurrencyObj, setCurrentCurrencyObj] = React.useState({})
  const formActions = useFormik({
    initialValues: {
      id: '',
      key: '',
      name_en: '',
      name_ar: '',
      rate: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: CurrencyFormValidation,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers, updateParentEntity)
    })
  })
  React.useEffect(() => {
      if (!!Object.keys(currentCurrencyObj || {}).length) {
        formActions.setFieldValue('name_en', currentCurrencyObj.name_en || '')
        formActions.setFieldValue('name_ar', currentCurrencyObj.name_ar || '')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentCurrencyObj])
  React.useEffect(() => {
      if (!!Object.keys(currentData || {}).length) {
        formActions.setFieldValue('id', currentData?.id || '')
        formActions.setFieldValue('key', currentData?.key || '')
        formActions.setFieldValue('name_en', currentData.name_en || '')
        formActions.setFieldValue('name_ar', currentData.name_ar || '')
        formActions.setFieldValue('rate', currentData?.rate || '')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentData])

  const DecimalChange = (event, fieldName) => {
    const re = /^[0-9]*\.?[0-9]*$/
    if (event.target.value === '' || re.test(event.target.value)) {
      formActions.setFieldValue(fieldName, event.target.value)
    }
  }
  const DecimalBlur = (event, fieldName) => {
    if (!!formActions.values.rate) {
      let value = calculateDecimal(event.target.value)
      formActions.setFieldValue(fieldName, value)
    }
  }

  return (
    <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off" className={classes.formWrapper}>

      <FormSelectField name={'key'} labelKey={'Fields.label.currency'}
                       list={currencyList?.filter(item => !currenciesKeys?.includes(item?.key))} classes={classes}
                       displayEmpty returnedObj={setCurrentCurrencyObj}
                       type={'currency'} formActions={formActions} locale={locale} required withKeyNext/>

      <FormTextField name={'rate'} labelKey={'Fields.label.exchangeRate'} classes={classes}
                     formActions={formActions} required
                     onChange={(event) => DecimalChange(event, 'rate')}
                     onBlurFn={(event) => DecimalBlur(event, 'rate')}
                     InputAttributes={{
                       endAdornment: <InputAdornment position="end"><FormattedMessage id='EGP'/></InputAdornment>
                     }}/>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                onClick={formActions.handleSubmit}
                disabled={formActions.isSubmitting || !formActions.isValid}
        >
          <FormattedMessage id={`AddNewDialog.AddNewRecord.${currentAction}`}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='invoiceSteps.Cancel'/>
        </Button>
      </div>
      {!!formActions.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default CurrencyForm
